<template>
    <div>
        <template v-if="viewPage === true && merchant !== null">
            <preLoader v-if="beneficiaryLoad === true"></preLoader>
            <div class="modal fade" id="merchantBeneficiaryPopup" tabindex="-1" role="dialog" aria-labelledby="merchantBeneficiaryPopupLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-5 text-left">
                            <div class="popup-head mb-4 line-head">
                                <h2 class="pb-3"> Payment Detail </h2>
                            </div>
                            <div class="people-management-inner-content">
                                <div class="form-group">
                                    <label class="label block-label">Payment to be transferred via <em class="required">*</em> </label>
                                    <label class="radio-holder ml-0 mb-0">
                                        SimSim
                                        <input type="radio" v-model="beneficiary_form.account_type" @click="paymentMethod = 'SIMSIM'" value="SIMSIM" class="payment-transfer" name="payment-transfer" checked="">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-holder mb-0">
                                        IBFT
                                        <input v-model="beneficiary_form.account_type" type="radio" @click="paymentMethod = 'IBFT'" value="IBFT" class="payment-transfer" name="payment-transfer">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="payment-via simsim" v-if="paymentMethod == 'SIMSIM'">
                                    <div class="form-group">
                                        <label class="label block-label"> Wallet Number  <em class="required">*</em> </label>
                                        <input type="text" placeholder="03XXXXXXXXX" class="form-control" name="wallet_number" v-model="beneficiary_form.wallet_number" :class="{ 'is-invalid': beneficiary_form.errors.has('wallet_number') }" autocomplete="off"/>
                                        <has-error :form="beneficiary_form" field="wallet_number"></has-error>
                                    </div>
                                    <a href="#" class="account fetch-info" title="" @click="getBeneficiaryDetail()"> Fetch Info </a>
                                    <div class="form-group detail-fetched" v-if="showWalletDetail">
                                        <div class="fetched-inner">
                                            <div class="fetched-image">
                                                <img src="/images/table-dummy-image.jpg" alt="" />
                                            </div>
                                            <div class="fetched-detail">
                                                <h3> {{ customerNumber }}  </h3>
                                                <p> {{mobileNumber}}  </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="payment-via bank"  v-show="paymentMethod == 'IBFT'">
                                    <div class="form-group">
                                        <label class="label block-label"> Bank Name <em class="required">*</em> </label>
                                        <select v-model="beneficiary_form.bank_name" name="bank_name" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': beneficiary_form.errors.has('bank_name') }" v-if="banks != null">
                                            <option value="" selected>Select Bank</option>
                                            <option v-for="bank in banks" v-bind:value="{bank_code : bank.bankBin, bank_name : bank.bankName}" v-bind:key="bank.bankBin">
                                                {{ bank.bankName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                                        <input type="text" placeholder="Account No." v-model="beneficiary_form.account_number" class="form-control" name="account_number" value="" :class="{ 'is-invalid': beneficiary_form.errors.has('account_number') }"/>
                                        <has-error :form="beneficiary_form" field="account_number"></has-error>
                                    </div>
                                    <h3 class="mb-3" v-if="showIBFTDetail"> Fetched Acount Details </h3>
                                    <a href="#" class="account get-info" title="" @click="getBeneficiaryDetail()"> Fetch Info </a>
                                    <div class="fethed-account-detail mb-3"  v-if="showIBFTDetail">
                                        <div class="row">
                                            <div class="col-5"> <strong class="title"> Bank Name </strong> </div>
                                            <div class="col-7"> {{bankName}} </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-5"> <strong class="title"> Account Number </strong> </div>
                                            <div class="col-7"> {{accountNumber}} </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-5"> <strong class="title"> Account Title </strong> </div>
                                            <div class="col-7"> {{accountTitle}} </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-5"> <strong class="title"> Branch Code </strong> </div>
                                            <div class="col-7"> {{branchCode}} </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-holder text-right">
                                    <button class="btn btn-primary" @click="hidePopup()"> Cancel </button>
                                    <button class="btn btn-primary" @click="addMerchantBeneficiary()" disable="disable"> Save </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Merchant Detail </h1>
            </div>
            <div class="vendor-profile-box mb-3">
                <div class="row mb-4">
                    <div class="col">
                        <div class="vendor-profile-head clearfix">
                            <h2> {{merchant.name}} </h2>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Phone </span>
                        <p class="value-text"> {{merchant.phone}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Email </span>
                        <p class="value-text"> {{merchant.email}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Address </span>
                        <p class="value-text"> {{merchant.address_1}} </p>
                    </div>
                </div>
            </div>
            <div class="row mb-12">
                <h3 class="vendor-profile-heading mb-3 float-left"> Beneficiaries </h3>
                <a href="#" class="float-right" @click="loadBankList">
                    <i class="fas fa-pencil-alt"></i>
                </a>
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
                    <table id="paymentDetail" class="table table-responsive-xl" style="width:100%">
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Account Type</th>
                            <th>Account Title</th>
                            <th>Bank</th>
                            <th>Account Number</th>
                            <th>Default</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(beneficiary, index) in merchantBeneficiaries" :key="index">
                            <td> {{index + 1}} </td>
                            <td>{{beneficiary.account_type}}</td>
                            <td>{{beneficiary.account_title}}</td>
                            <td>{{beneficiary.bank_name}}</td>
                            <td>{{beneficiary.account_number}}</td>
                            <td v-if="beneficiary.is_default == 'YES'">{{beneficiary.is_default}}</td>
                            <td v-if="beneficiary.is_default == 'NO'"><a href="javascript:void(0);" @click="makeDefault(beneficiary.id);">Make Default</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === null && merchant === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage : null,
                beneficiaryLoad : false,
                merchant : null,
                merchantBeneficiaries : null,
                banks : null,
                paymentMethod : 'SIMSIM',
                showWalletDetail : false,
                showIBFTDetail : false,
                customerName : '',
                mobileNumber : '',
                bankName :false,
                accountNumber :false,
                beneficiary_form: new Form({
                    account_type : 'SIMSIM',
                    bank_name : '',
                    wallet_number : '',
                    account_number : '',
                    account_title : '',
                    branch_code : '',
                    is_default : 'NO',
                    id: this.$route.params.id
                }),
                make_default : new Form({
                    id : '',
                    uid: this.$route.params.id
                }),
            };
        },
        mounted() {
            this.$Progress.start();
            this.getmerchantDetailData();
            this.$Progress.finish();
        },
        methods: {
            makeDefault(id){
                this.$Progress.start();
                this.make_default.id = id;
                this.make_default.post('/api/makeCompanyDefaultBeneficiary')
                .then(res => {
                    if (res.status == 200) {
                        this.getmerchantDetailData();
                        this.showToastBox('success','Company account set to default successfully');
                        this.$Progress.finish();
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getmerchantDetailData : function () {
                axios.get('/api/merchantCompanyDetail/'+this.$route.params.id)
                    .then(res => {
                        if(res.status == 200){
                            this.viewPage = res.data.viewPage;
                            this.merchant = res.data.merchant;
                            this.merchantBeneficiaries = res.data.merchantBeneficiaries;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load fee  voucher detail');
                        }
                    })
                    .then(res =>{
                        var merchantPaymentsTable = $('#paymentDetail').DataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                            deferRender: true,
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load fee  vouhcer detail');
                    });
            },
            loadBankList(){
                this.beneficiaryLoad = true;
                axios.get('/api/ibftBankList')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.bankList != null){
                            this.banks = res.data.bankList;
                        }
                        this.beneficiaryLoad = false;
                        $("#merchantBeneficiaryPopup").modal("show");
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Error to load data');
                });
            },
            hidePopup(){
                $('#merchantBeneficiaryPopup').modal('hide');
                this.showWalletDetail = this.showIBFTDetail = false;
            },
            addMerchantBeneficiary() {
                this.$Progress.start();
                this.beneficiary_form.post('/api/addMerchantBeneficiary/'+this.beneficiary_form.id)
                .then(res => {
                    console.log(res);
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Company beneficiary added successfully');
                            $("#merchantBeneficiaryPopup").modal("hide");
                            this.beneficiaryLoad = true;
                            this.getmerchantDetailData();
                            this.beneficiaryLoad = false;
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error','Beneficiary details already added against this company.');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data inside');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data outside');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    console.log(err);
                    this.showAlertBox('error','Some problem in your form data call failed');
                });
            },
            getBeneficiaryDetail(){
                var walletNumber = this.beneficiary_form.wallet_number;
                var account_type = this.beneficiary_form.account_type;
                var bank_name = this.beneficiary_form.bank_name.bank_code;
                var account_number = this.beneficiary_form.account_number;
                var user_id = this.beneficiary_form.id;
                this.$Progress.start();
                axios.post('/api/validateBeneficiary', {
                    walletNumber: walletNumber,
                    account_type: account_type,
                    bankCode: bank_name,
                    toAccountNumber: account_number,
                    user_id: user_id,
                })
                .then(res => {
                    if(res.data.code == 200){
                        if(account_type == 'SIMSIM'){
                            this.customerNumber = res.data.data.customerName;
                            this.mobileNumber = res.data.data.mobileNumber;
                            this.beneficiary_form.account_title = res.data.data.customerName;
                            this.showWalletDetail = true;
                        }else{
                            this.bankName = this.beneficiary_form.bank_name.bank_name;
                            this.accountNumber = this.beneficiary_form.account_number;
                            this.beneficiary_form.account_title = this.accountTitle = res.data.data.accountTitle;                            
                            this.beneficiary_form.branch_code = this.branchCode = this.beneficiary_form.bank_name.bank_code;
                            this.showIBFTDetail = true;
                        }
                        this.$Progress.finish();
                    }else if(res.data.status == 409){
                        this.showAlertBox('error','Beneficiary already exist');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        created() {
            //
        }
    }
</script>
